<template>
  <aside id="left-col" class="uk-light uk-visible@m">
    <div class="left-logo uk-flex uk-flex-middle">
      <img class="custom-logo uk-margin-small-right" src="img/logo.png" alt="">
      <div class="uk-h2 uk-margin-top uk-text-lighter">Admin</div>
    </div>
    <div class="left-content-box content-box-dark">
      <img src="/assets/user.svg" alt="" class="uk-border-circle profile-img" data-uk-svg>
      <!--<span class="profile-img" data-uk-icon="icon:user; ratio:3"></span>-->
      <h4 class="uk-text-center uk-margin-remove-vertical text-light" v-if="user.data">{{ user.data.identifier }}</h4>

      <div class="uk-position-relative uk-text-center uk-display-block">
        <a
          href="#"
          class="uk-text-small uk-text-muted uk-display-block uk-text-center uk-icon"
          data-uk-icon="icon: triangle-down; ratio: 0.7"
          aria-expanded="false"
          v-if="user.data"
        >{{ user.data.tenant.name}}</a>
        <!-- user dropdown -->
        <div
          class="uk-dropdown user-drop uk-dropdown-bottom-center"
          data-uk-dropdown="mode: click; pos: bottom-center; animation: uk-animation-slide-bottom-small; duration: 150"
          style="left: 20px; top: 21px;"
        >
          <ul class="uk-nav uk-dropdown-nav uk-text-left">
            <li>
              <a href="#" @click.prevent="logout">
                <span data-uk-icon="icon: sign-out" class="uk-icon"></span> Abmelden
              </a>
            </li>
          </ul>
        </div>
        <!-- /user dropdown -->
      </div>
    </div>
    <div class="left-nav-wrap">
      <ul class="uk-nav uk-nav-default uk-nav-parent-icon" data-uk-nav>
        <router-link tag="li" :to="{name: 'dashboard'}" exact>
          <a>
            <span data-uk-icon="icon: home"></span> Dashboard
          </a>
        </router-link>
        <router-link tag="li" :to="{name: 'pages'}">
          <a>
            <span data-uk-icon="icon: copy"></span> Seiten
          </a>
        </router-link>
        <router-link tag="li" :to="{name: 'blog'}">
          <a>
            <span data-uk-icon="icon: wordpress"></span> Blog
          </a>
        </router-link>
        <!--
        <router-link tag="li" :to="{name: 'press'}">
          <a>
            <span data-uk-icon="icon: commenting"></span> Pressebereich
          </a>
        </router-link>
        -->
        <router-link tag="li" :to="{name: 'media'}">
          <a>
            <span data-uk-icon="icon: image"></span> Medien
          </a>
        </router-link>
      </ul>
    </div>
    <div class="bar-bottom">
      <ul class="uk-subnav uk-flex uk-flex-center uk-child-width-1-5" data-uk-grid>
        <router-link tag="li" :to="{name: 'settings'}" class="uk-visible@m">
          <a
            href="#"
            data-uk-icon="icon: cog"
            title="Einstellungen"
            data-uk-tooltip
          ></a>
        </router-link>
        <li class="uk-visible@m">
          <a
            href="#"
            data-uk-icon="icon: sign-out"
            title="Abmelden"
            data-uk-tooltip
            @click.prevent="logout"
            >
          </a>
        </li>
      </ul>
    </div>
  </aside>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  data () {
    return {
      //
    }
  },
  computed: {
    ...mapGetters({
      customers: 'customers',
      customer: 'customer',
      user: 'auth/user'
    }),
    selectedCustomer: {
      get () {
        return this.$store.state.customer
      },
      set (value) {
        this.$store.dispatch('switchCustomer', value)
      }
    }
  },

  methods: {
    ...mapActions({
      logout: 'auth/logout'
    })
  }
}
</script>
